<template>
  <el-dialog
    :title="$t('eventList.AppPro')"
    :visible.sync="dialogVisible"
    width="40%"
    class="approvalProcessDialog"
  >
    <el-scrollbar class="approvalProcessScrollbar">
      <commonProcess :process-data="activityProcessData" />
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import commonProcess from 'components/commonProcess';
import { activityQuery } from '@/views/activitieList/service';
export default {
  data () {
    return {
      dialogVisible: false,
      activityProcessData: []
    };
  },
  components: {
    commonProcess
  },
  methods: {
    init (parameter) {
      const { dialogVisible, id } = parameter;
      this.dialogVisible = dialogVisible;
      activityQuery.complianceProcessHistory(id).then(res => {
        if (res.status === '200') {
          const result = JSON.parse(JSON.stringify(res.data));
          if (result && result.length > 0) {
            let data = result[0].processHistoryVO;
            this.activityProcessData = data.mactFlowLogList.map(item => {
              return {
                title: item.node,
                details: item.reason,
                type: item.approveType,
                name: item.assigneeName,
                time: item.createTime,
                active: data.processState === 'completed'
              };
            });
            if (data.processState === 'completed') {
              this.activityProcessData = [
                ...this.activityProcessData,
                {
                  name: this.$t('general.End'),
                  active: true
                }
              ];
            }
          }
        }
      });
      this.$nextTick(() => {
            let ele = document.querySelector('.approvalProcessScrollbar>.el-scrollbar__wrap');
            ele.scrollTo(0, ele.scrollHeight);
          });
    }
  }
};
</script>

<style lang="scss" scoped>
.approvalProcessDialog{
  ::v-deep.el-dialog{
    .approvalProcessScrollbar{
      >.el-scrollbar__wrap {
        overflow-x: hidden;
        max-height: 500px;
      }
    }
    .processTitle{
      font-size: 14px;
      font-weight: bold;
      margin-bottom: 16px;
      &~.processTitle{
        margin-top: 10px;
      }
    }
  }
}
</style>
